import React, {
    Fragment,
    useCallback,
    useEffect,
    useRef,
    useState,
} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    Badge,
    Box,
    Button,
    Grid,
    IconButton,
    List,
    ListItem,
    Typography,
    Paper,
    useTheme,
} from '@material-ui/core';

import {
    member as v_member,
    basic,
    Values,
    member,
    material,
    SNACKBAR_TIME,
} from '../../request/values';
import { COLORS } from '../Theme';
import { useHistory } from 'react-router-dom';
import TitleBar from '../header/TitleBar';
import NumberFormat from 'react-number-format';
import axios from 'axios';
import { DialogConfirm, DialogSelectCompany } from '../Dialog';
import clsx from 'clsx';
import { useSnackbar } from 'notistack';
import ToastStr from '../../request/toastStr';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { maxWidth } from '@material-ui/system';

const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
    titleIcon: {
        width: '5vw',
        height: 'auto',
    },
    list: {
        padding: '1vw',
        height: '69.5vh',
        overflowY: 'auto',
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        fontSize: '4vw',
        //alignContent: 'center',
        [theme.breakpoints.up('md')]: {
            height: '100%',
            paddingBottom: theme.spacing(15),
        },
    },
    drawerOpenList: {
        height: '50vh',
    },

    materialItem: {
        // borderRadius: 12,
        border: `solid 1px ${COLORS.VERY_LIGHT_PINK}`,
        marginBottom: '1.5vh',
        padding: 0,
        borderRadius: '5px',
    },
    materialImage: {
        textAlign: 'center',
        margin: 'auto',
        '& img': {
            width: '14vw',
            maxWidth: '100px',
            [theme.breakpoints.up('lg')]: {
                width: '55px',
            },
        },
    },
    icon: {
        width: '5vw',
        maxWidth: '38px',
    },
    materialDesc: {
        '& #materialName': {
            ...theme.typography.subtitle2,
        },
        '& #materialSubName': {
            ...theme.typography.body1,
            color: `${COLORS.BROWNISH_GREY}`,
        },
    },
    materialButtonSection: {
        '& #price': {
            margin: 'auto',
            textAlign: 'center',
            ...theme.typography.subtitle2,
        },
        '& #count': {
            margin: 'auto',
            textAlign: 'center',
            ...theme.typography.subtitle2,
        },
    },

    materialBottomBar: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        display: 'block',
        width: '100%',
        height: '11vh',
        // marginLeft: '-2.5vw',
        backgroundColor: `${COLORS.LIGHT_GREY}`,

        '& #saleButton': {
            borderRadius: '10px',
            boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
            backgroundColor: `${COLORS.WHITE}`,
            color: `${COLORS.WATER_BLUE}`,
            ...theme.typography.h4,
            fontFamily: 'NanumB',
            fontWeight: 'bold',
        },
        '& .MaterialBottomicon': {
            width: '7.4vw',
            maxWidth: '60px',
        },
        [theme.breakpoints.up('md')]: {
            width: 'calc(100% - 290px)',
            left: '290px',
        },
    },
    number: {
        margin: 'auto 0',
        ...theme.typography.body1,
        [theme.breakpoints.up('md')]: {
            ...theme.typography.h3,
            color: 'f000',
        },
    },
    drawerOpenBomttomBar: {
        height: '32vh',
    },

    basketItem: {
        display: 'flex',
        width: '93vw',
        height: '6.5vh',
        alignItems: 'center',

        padding: '1vh 4vw',
        fontFamily: 'NanumB',
        fontWeight: 'bold',

        borderRadius: '12px',
        border: 'solid 1px #e4e4e4',
        backgroundColor: `${COLORS.WHITE}`,
        // "& img": {
        //     width: '9vw',
        // }
        '& #imageSection': {
            width: '20%',
        },
        '& #imageSection img': {
            width: '50%',
        },

        '& #nameSection': {
            width: '48%',
            color: `${COLORS.CHARCOAL_GREY}`,
        },

        '& #descSection': {
            textAlign: 'right',
            width: '18%',
            fontSize: '3vw',
        },
        [theme.breakpoints.up('md')]: {
            height: '11.5vh',
        },
    },

    button: {
        width: 'auto',
        height: 'auto',
        borderRadius: '5px',
        backgroundColor: `${COLORS.WATER_BLUE}`,
        color: `${COLORS.LIGHT_GREY}`,
        padding: '1vw',
        ...theme.typography.body1,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
    },
    empty: {
        height: '58vh',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& img': {
            width: '35vw',
            height: '35vw',
            [theme.breakpoints.up('md')]: {
                width: '25vw',
                height: '25vw',
            },
            marginBottom: '2.5vh',
        },
        '& h1': {
            color: `${COLORS.DOWN}`,
        },
    },
    paper: {
        padding: theme.spacing(1),
    },
    grid: {
        marginTop: theme.spacing(1),
    },
}));

interface iMaterialList {
    materialCode: number;
    materialName: string;
    materialSubName: string;
    materialImage: string;
    materialPrice: number;
    quantity: number;
    materialCount: number;
}

interface iCart {
    code: number;
    quantity: number;
    price: number;
}

interface iCompanyInfo {
    companyNum: number;
    companyName: string;
}

const MaterialPurchase: React.FC<any> = (props) => {
    const classes = useStyles();
    const { member } = props;
    const history = useHistory();
    const state: any = history.location.state;
    const [companyType, setCompanyType] = useState<string>('');

    const [totalPrice, setTotalPrice] = useState(0);
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [material, setMaterial] = useState<iMaterialList[]>([]);
    const [companyList, setCompanyList] = useState<iCompanyInfo[]>([]);
    const [dialog, setDialog] = useState<boolean>(false);
    const [drawer, setDrawer] = useState<boolean>(false);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const count = 20;
    let max_count: number = 999;

    const [page, setPage] = useState(-count);
    const loader = useRef(null);

    const theme = useTheme();
    const isLargeUp = useMediaQuery(theme.breakpoints.up('lg'));

    // useEffect(() => {
    //     console.log('history?', history)

    //     if (history !== undefined) {
    //         return history.listen((location:any) => {
    //             console.log('location action?', location)
    //             console.log(`You changed the page to: ${location.pathname}`)

    //         })
    //     } else {
    //         return;
    //     }

    // }, [history])
    /*
    const getCompanyType = () => {
        console.log('in appstandby member,', member)
        let url = new URL(SERVER + v_member.member + v_member.company_type);
        let params = { 'companyNum': companyNum}
        url.search = new URLSearchParams(params).toString();

        axios({
            method: "GET",
            withCredentials: true,
            url: url.toString()
        }).then((res) => res.data).then((data: any) => {
            console.log(data)
            if (data.code == Values.SUCCESS_CODE) {
                //console.log(data.data[0].company_type)
                setCompanyType(data.companyType)
                console.log(companyType)
            } else if (data.code == Values.FAIL_CODE) {
                enqueueSnackbar(ToastStr.COMPANY_APP_INFO_FAIL_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME })
            } else {
                enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, { variant: "error", autoHideDuration: SNACKBAR_TIME })
            }
        })
    }
    
    useEffect(() => {
        getCompanyType()
    }, [])
    */
    const handleObserver = useCallback((entries: any) => {
        const target = entries[0];
        if (target.isIntersecting) {
            setPage((prevState) => {
                if (prevState + count > max_count) {
                    return prevState;
                }
                return prevState + count;
            });
        }
    }, []);

    const refreshCartList = () => {
        setMaterial((prevState) => {
            prevState.forEach((item) => (item.quantity = 0));
            return prevState;
        });
        setTotalPrice(0);
        setTotalQuantity(0);
    };

    const moveMaterialOrder = () => {
        history.push({
            pathname: '/OrderList',
        });
    };

    const handleDialogClose = () => {
        setDialog((prevState) => !prevState);
    };

    const handleDialogOpen = () => {
        if (
            !dialog &&
            material.filter((item) => item.quantity > 0).length > 0
        ) {
            setDialog((prevState) => !prevState);
        }
    };

    const handleDrawerClose = () => {
        setDrawer((prevState) => !prevState);
    };

    const handleDrawerOpen = () => {
        console.log('click open drawer btn');
        if (
            !dialog &&
            material.filter((item) => item.quantity > 0).length > 0
        ) {
            setDrawer((prevState) => !prevState);
        }
    };

    const setShoppingCart = (
        e: any,
        code: number,
        price: number,
        status: string
    ) => {
        e.preventDefault();

        if (status === '+') {
            let m = material;
            let i = m.findIndex((item: any) => item.materialCode == code);
            if (i != -1) {
                setMaterial((prevState) => [
                    ...prevState.slice(0, i),
                    {
                        ...prevState[i],
                        quantity: prevState[i].quantity + 1,
                    },
                    ...prevState.slice(i + 1),
                ]);
                setTotalPrice((prevState) => prevState + m[i].materialPrice);
                setTotalQuantity((prevState) => prevState + 1);
            }
        } else if (status === '-') {
            let m = material;
            let i = m.findIndex((item) => item.materialCode == code);

            if (i != -1 && m[i].quantity != 0) {
                setMaterial((prevState) => [
                    ...prevState.slice(0, i),
                    {
                        ...prevState[i],
                        quantity: prevState[i].quantity - 1,
                    },
                    ...prevState.slice(i + 1),
                ]);
                setTotalPrice((prevState) => prevState - m[i].materialPrice);
                setTotalQuantity((prevState) => prevState - 1);
            }
        }
    };

    const AddComma = (num: number) => {
        var regexp = /\B(?=(\d{3})+(?!\d))/g;
        return num.toString().replace(regexp, ',');
    };

    async function getMaxMaterialCount(): Promise<number> {
        let url = new URL(
            basic.server + v_member.member + v_member.material_count
        );
        let params = { classVersion: member.classVersion };
        url.search = new URLSearchParams(params).toString();

        const response = await axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        });
        const data = await response.data;
        const count: number = data.count.count;
        return count;
    }

    const getCompanyList = () => {
        let url = new URL(
            basic.server + v_member.member + v_member.decompose_company_list
        );
        let params = { classCode: member.classCode };
        url.search = new URLSearchParams(params).toString();

        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => res.data)
            .then((data: any) => {
                if (data.code == Values.SUCCESS_CODE) {
                    setCompanyList(data.companyList);
                    console.log('company list? ', data.companyList);
                }
            });
    };

    const getMaterialList = (position: number, count: number) => {
        console.log('in getMaterialList position', position);

        let url = new URL(
            basic.server + v_member.member + v_member.material_list
        );
        let params = {
            position: position.toString(),
            count: count.toString(),
            classVersion: member.classVersion,
        };
        url.search = new URLSearchParams(params).toString();

        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => res.data)
            .then((data: any) => {
                if (data.code == Values.SUCCESS_CODE) {
                    setMaterial((prevState) =>
                        prevState.concat(
                            data.materials.map((item: any) =>
                                Object.assign(item, { quantity: 0 })
                            )
                        )
                    );
                }
            });
    };

    // const postMaterialOrder = () => {
    //     let url = new URL(
    //         basic.server + v_member.member + v_member.material_order
    //     );
    //     const cartList = material.filter((item) => item.quantity > 0);

    //     if (cartList.length === 0) {
    //         handleDialogClose();
    //         return;
    //     }

    //     axios({
    //         method: 'POST',
    //         data: {
    //             companyNum: member.companyNum,
    //             classCode: member.classCode,
    //             memberEmail: member.id,
    //             memberName: member.name,
    //             cartList: material.filter((item) => item.quantity > 0),
    //         },
    //         withCredentials: true,
    //         url: url.toString(),
    //     })
    //         .then((res) => res.data)
    //         .then((data: any) => {
    //             if (data.code == Values.SUCCESS_CODE) {
    //                 refreshCartList();
    //                 enqueueSnackbar('재료 주문을 성공했습니다.', {
    //                     variant: 'success',
    //                     autoHideDuration: SNACKBAR_TIME,
    //                     translate: 'no',
    //                 });
    //                 // props.setLicenseStatus(e, 'complete', data.regDate.development_date)
    //             } else if (data.code == Values.INSUFFICIENT_CODE) {
    //                 enqueueSnackbar('현금자산이 부족하여 구매가 불가합니다.', {
    //                     variant: 'warning',
    //                     autoHideDuration: SNACKBAR_TIME,
    //                     translate: 'no',
    //                 });
    //             } else if (data.code == Values.FAIL_CODE) {
    //                 if (data.msg)
    //                     enqueueSnackbar(data.msg, {
    //                         variant: 'warning',
    //                         autoHideDuration: SNACKBAR_TIME,
    //                         translate: 'no',
    //                     });
    //                 else
    //                     enqueueSnackbar('재료 주문이 실패했습니다.', {
    //                         variant: 'warning',
    //                         autoHideDuration: SNACKBAR_TIME,
    //                         translate: 'no',
    //                     });
    //             } else {
    //                 if (data.msg)
    //                     enqueueSnackbar(data.msg, { variant: 'error' });
    //                 else
    //                     enqueueSnackbar('재료 주문에서 오류가 발생했습니다.', {
    //                         variant: 'error',
    //                         autoHideDuration: SNACKBAR_TIME,
    //                         translate: 'no',
    //                     });
    //             }
    //         });
    //     handleDialogClose();
    // };

    const postMaterialOrderCompany = (companyNum: number) => {
        if (companyNum === undefined || companyNum === 0) {
            enqueueSnackbar('구매할 회사를 선택해주세요.', {
                variant: 'warning',
                autoHideDuration: SNACKBAR_TIME,
                translate: 'no',
            });
            return;
        }

        let url = new URL(
            basic.server + v_member.member + v_member.material_order
        );
        const cartList = material.filter((item) => item.quantity > 0);

        if (cartList.length === 0) {
            handleDialogClose();
            return;
        }

        axios({
            method: 'POST',
            data: {
                companyNum: member.companyNum,
                classCode: member.classCode,
                memberEmail: member.id,
                memberName: member.name,
                cartList: material.filter((item) => item.quantity > 0),
                decomposeCompanyNum: companyNum,
            },
            withCredentials: true,
            url: url.toString(),
        })
            .then((res) => res.data)
            .then((data: any) => {
                if (data.code == Values.SUCCESS_CODE) {
                    refreshCartList();
                    enqueueSnackbar('재료 주문을 성공했습니다.', {
                        variant: 'success',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                    // props.setLicenseStatus(e, 'complete', data.regDate.development_date)
                } else if (data.code == Values.INSUFFICIENT_CODE) {
                    enqueueSnackbar('현금자산이 부족하여 구매가 불가합니다.', {
                        variant: 'warning',
                        autoHideDuration: SNACKBAR_TIME,
                        translate: 'no',
                    });
                } else if (data.code == Values.FAIL_CODE) {
                    if (data.msg)
                        enqueueSnackbar(data.msg, {
                            variant: 'warning',
                            autoHideDuration: SNACKBAR_TIME,
                            translate: 'no',
                        });
                    else
                        enqueueSnackbar('재료 주문이 실패했습니다.', {
                            variant: 'warning',
                            autoHideDuration: SNACKBAR_TIME,
                            translate: 'no',
                        });
                } else {
                    if (data.msg)
                        enqueueSnackbar(data.msg, { variant: 'error' });
                    else
                        enqueueSnackbar('재료 주문에서 오류가 발생했습니다.', {
                            variant: 'error',
                            autoHideDuration: SNACKBAR_TIME,
                            translate: 'no',
                        });
                }
            });
        handleDialogClose();
    };

    useEffect(() => {
        const option = {
            root: null,
            rootMargin: '20px',
            threshold: 0,
        };
        // console.log('in infinite useEffect')
        const observer = new IntersectionObserver(handleObserver, option);
        if (loader.current) observer.observe(loader.current!);
    }, [handleObserver]);

    useEffect(() => {
        const init = async () => {
            getCompanyList();
            refreshCartList();
            max_count = await getMaxMaterialCount();
        };
        init();
    }, []);

    useEffect(() => {
        if (page >= 0) {
            getMaterialList(page, count);
        }
    }, [page]);

    return (
        <div className="content">
            <div
                style={{
                    textAlign: 'right',
                    marginLeft: 'auto',
                    paddingTop: '1vh',
                    paddingBottom: '1vh',
                }}
            >
                <Button
                    className={classes.button}
                    variant="contained"
                    onClick={moveMaterialOrder}
                >
                    <div>재료 영수증</div>
                </Button>
            </div>
            {/* {isLargeUp ? (
              <Grid container className={classes.grid} spacing={3}>
                {material.length != 0 ? (
                        material.map((item: any, index: number) => {
                            return (
                               <Grid item xs={12} md={6} key={index}>
                                <Paper className={classes.paper}>
                                    <MaterialItem
                                        key={index}
                                        member={member}
                                        {...item}
                                        quantity={item.quantity}
                                        setShoppingCart={(
                                            e: any,
                                            code: number,
                                            status: string
                                        ) =>
                                            setShoppingCart(
                                                e,
                                                code,
                                                item.materialPrice,
                                                status
                                            )
                                        }
                                    ></MaterialItem>
                                    </Paper>
                                </Grid>
                            );
                        })
                    ) : (
                      <Grid item xs={12}>
                        <div className={classes.empty}>
                            <div>
                                <img src="/images/title/product2.webp" />
                                <Typography variant="h1">
                                    구매 가능한 재료가 없습니다.
                                </Typography>
                            </div>
                        </div>
                        </Grid>
                    )}
                    <div ref={loader}></div>
              </Grid>
            ):( */}
            <Box>
                <List
                    className={
                        drawer === false
                            ? classes.list
                            : clsx(classes.list, classes.drawerOpenList)
                    }
                >
                    {material.length != 0 ? (
                        material.map((item: any, index: number) => {
                            return (
                                <ListItem className={classes.materialItem}>
                                    <MaterialItem
                                        key={index}
                                        member={member}
                                        {...item}
                                        quantity={item.quantity}
                                        setShoppingCart={(
                                            e: any,
                                            code: number,
                                            status: string
                                        ) =>
                                            setShoppingCart(
                                                e,
                                                code,
                                                item.materialPrice,
                                                status
                                            )
                                        }
                                    ></MaterialItem>
                                </ListItem>
                            );
                        })
                    ) : (
                        <div className={classes.empty}>
                            <div>
                                <img src="/images/title/product2.webp" />
                                <Typography variant="h1">
                                    구매 가능한 재료가 없습니다.
                                </Typography>
                            </div>
                        </div>
                    )}
                    <div ref={loader}></div>
                </List>
            </Box>
            {/* )} */}
            <MaterialBottomBar
                totalPrice={totalPrice}
                totalQuantity={totalQuantity}
                basket={material.filter((item) => item.quantity > 0)}
                drawerState={drawer}
                handleOrder={handleDialogOpen}
                handleBasket={handleDrawerOpen}
            />
            {/* <DialogConfirm
                open={dialog}
                handleClose={handleDialogClose}
                title={'구매완료 하시겠습니까?'}
                context={getDialogContext()}
                yesConfirm={postMaterialOrder}
                noConfirm={handleDialogClose}
            /> */}
            <DialogSelectCompany
                open={dialog}
                handleClose={handleDialogClose}
                title={'구매할 회사를 선택해주세요.'}
                companyList={companyList}
                //context={getDialogContext()}
                context={`총 금액: ${AddComma(totalPrice)}원`}
                yesConfirm={postMaterialOrderCompany}
                //yesConfirm={postMaterialOrder}
                noConfirm={handleDialogClose}
            />
        </div>
    );
};

const MaterialItem: React.FC<any> = (props) => {
    const classes = useStyles();

    const setCart = (e: any, status: string) => {
        props.setShoppingCart(e, props.materialCode, status);
    };
    return (
        <Grid container justify={'center'} alignContent="center" translate="no">
            <Grid xs={3} className={classes.materialImage}>
                <img
                    src={
                        basic.server +
                        '/displayImage?fileName=' +
                        props.materialImage
                    }
                />
            </Grid>
            <Grid xs={5} style={{ margin: 'auto' }}>
                <Grid
                    container
                    className={classes.materialDesc}
                    direction="column"
                >
                    <Grid id="materialName">{props.materialName}</Grid>
                    <Grid id="materialSubName">
                        {props.materialSubName} {props.materialCode}
                    </Grid>
                </Grid>
            </Grid>
            <Grid xs={4}>
                <Grid
                    container
                    className={classes.materialButtonSection}
                    direction="column"
                    alignItems="center"
                >
                    <Grid container direction="row">
                        <Grid xs={4}>
                            <IconButton>
                                <img
                                    className={classes.icon}
                                    src={`/images/price.webp`}
                                />
                            </IconButton>
                        </Grid>
                        <Grid xs={5} id="price">
                            <NumberFormat
                                value={props.materialPrice}
                                displayType={'text'}
                                thousandSeparator={true}
                                suffix={'원'}
                            />
                        </Grid>
                        <Grid xs={3}></Grid>
                    </Grid>
                    <Grid container alignItems="center">
                        <Grid xs={4}>
                            <IconButton onClick={(e: any) => setCart(e, '-')}>
                                <img
                                    className={classes.icon}
                                    src={
                                        props.quantity > 0
                                            ? `/images/minus_button_blue.webp`
                                            : `/images/minus_button.webp`
                                    }
                                />
                            </IconButton>
                        </Grid>
                        <Grid xs={4} id="count">
                            <NumberFormat
                                value={props.quantity}
                                displayType={'text'}
                                thousandSeparator={true}
                                suffix={'개'}
                            />
                        </Grid>
                        <Grid xs={4}>
                            <IconButton onClick={(e: any) => setCart(e, '+')}>
                                <img
                                    className={classes.icon}
                                    src={`/images/plus_button_blue.webp`}
                                />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

const MaterialBottomBar: React.FC<any> = (props) => {
    const classes = useStyles();

    const {
        handleOrder,
        handleBasket,
        totalQuantity,
        totalPrice,
        drawerState,
        basket,
    } = props;

    return (
        <div
            className={
                drawerState === false
                    ? classes.materialBottomBar
                    : clsx(
                          classes.materialBottomBar,
                          classes.drawerOpenBomttomBar
                      )
            }
            translate="no"
        >
            {drawerState && (
                <List style={{ height: '21vh', overflowY: 'auto' }}>
                    {basket != null &&
                        basket.map((item: any, index: number) => {
                            return (
                                <ListItem>
                                    <MaterialBasketItem
                                        key={index}
                                        quantity={item.quantity}
                                        materialName={item.materialName}
                                        materialPrice={item.materialPrice}
                                        materialImage={item.materialImage}
                                    />
                                </ListItem>
                            );
                        })}
                </List>
            )}

            <Grid
                container
                alignItems="center"
                alignContent="center"
                style={{ height: '11vh' }}
            >
                <Grid
                    item
                    xs={4}
                    style={{ display: 'flex', justifyContent: 'center' }}
                >
                    <Badge badgeContent={totalQuantity} color="error">
                        <IconButton
                            onClick={handleBasket}
                            style={{ padding: 0 }}
                        >
                            <img
                                className="MaterialBottomicon"
                                src={`/images/title/cart.webp`}
                            />
                        </IconButton>
                    </Badge>
                </Grid>
                <Grid
                    item
                    xs={4}
                    style={{ display: 'flex', justifyContent: 'center' }}
                >
                    <img
                        className="MaterialBottomicon"
                        style={{ marginRight: '1vw' }}
                        src={`/images/price.webp`}
                    />
                    <NumberFormat
                        className={classes.number}
                        value={totalPrice}
                        displayType={'text'}
                        thousandSeparator={true}
                        suffix={'원'}
                    />
                </Grid>
                <Grid
                    item
                    xs={4}
                    style={{ display: 'flex', justifyContent: 'center' }}
                >
                    <Button
                        onClick={handleOrder}
                        variant="contained"
                        id="saleButton"
                    >
                        구매하기
                    </Button>
                </Grid>
            </Grid>
        </div>
    );
};

const MaterialBasketItem: React.FC<any> = (props) => {
    const classes = useStyles();
    const { quantity, materialName, materialPrice, materialImage } = props;

    return (
        <div className={classes.basketItem} translate="no">
            <div id="imageSection">
                <img
                    src={
                        basic.server + '/displayImage?fileName=' + materialImage
                    }
                />
            </div>

            <div id="nameSection">
                <Typography variant="h2">{materialName}</Typography>
            </div>
            <div id="descSection">
                <Typography
                    display="inline"
                    variant="h2"
                    style={{
                        color: `${COLORS.WATER_BLUE}`,
                        fontWeight: 'bold',
                    }}
                >
                    {quantity}
                </Typography>
                <Typography
                    display="inline"
                    variant="h1"
                    style={{
                        color: `${COLORS.BROWNISH_GREY}`,
                        fontWeight: 'bold',
                    }}
                >
                    개
                </Typography>
            </div>
            <div id="descSection">
                <Typography
                    display="inline"
                    variant="h2"
                    style={{
                        color: `${COLORS.WATER_BLUE}`,
                        fontWeight: 'bold',
                    }}
                >
                    {materialPrice * quantity}
                </Typography>
                <Typography
                    display="inline"
                    variant="h1"
                    style={{
                        color: `${COLORS.BROWNISH_GREY}`,
                        fontWeight: 'bold',
                    }}
                >
                    원
                </Typography>
            </div>
        </div>
    );
};

export default MaterialPurchase;
